export default __webpack_public_path__ + "static/media/banner-image.bf65e16e.png";